/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { OpaPolicy } from '../models/opa-policy';
import { EnableDisableOPAPolicy } from '../models/enable-disable-opapolicy';
import { PolicyTemplateDTO } from '../models/policy-template-dto';
import { OpaPolicyRequest } from '../models/opa-policy-request';
import { OpaPolicyExecutionResult } from '../models/opa-policy-execution-result';

/**
 * Ui Opa Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiOpaControllerService extends __BaseService {
  static readonly getAllPoliciesUsingGETPath = '/cc-ui/v1/opa';
  static readonly bulkEditOpaPolicyStateUsingPOSTPath =
    '/cc-ui/v1/opa/enable-disable-policies';
  static readonly getAllPolicyTemplatesUsingGETPath =
    '/cc-ui/v1/opa/policy-templates';
  static readonly getPolicyUsingGETPath = '/cc-ui/v1/opa/{policyName}';
  static readonly createPolicyUsingPOSTPath = '/cc-ui/v1/opa/{policyName}';
  static readonly editPolicyUsingPUTPath = '/cc-ui/v1/opa/{policyName}';
  static readonly deletePolicyUsingDELETEPath = '/cc-ui/v1/opa/{policyName}';
  static readonly executePolicyUsingPOSTPath =
    '/cc-ui/v1/opa/{policyName}/execute';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * getAllPolicies
   * @return OK
   */
  getAllPoliciesUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<OpaPolicy>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/opa`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<OpaPolicy>>;
      }),
    );
  }
  /**
   * getAllPolicies
   * @return OK
   */
  getAllPoliciesUsingGET(): __Observable<Array<OpaPolicy>> {
    return this.getAllPoliciesUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<OpaPolicy>),
    );
  }

  /**
   * bulkEditOpaPolicyState
   * @param enableDisableOPAPoliciesList enableDisableOPAPoliciesList
   */
  bulkEditOpaPolicyStateUsingPOSTResponse(
    enableDisableOPAPoliciesList: Array<EnableDisableOPAPolicy>,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = enableDisableOPAPoliciesList;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/opa/enable-disable-policies`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * bulkEditOpaPolicyState
   * @param enableDisableOPAPoliciesList enableDisableOPAPoliciesList
   */
  bulkEditOpaPolicyStateUsingPOST(
    enableDisableOPAPoliciesList: Array<EnableDisableOPAPolicy>,
  ): __Observable<null> {
    return this.bulkEditOpaPolicyStateUsingPOSTResponse(
      enableDisableOPAPoliciesList,
    ).pipe(__map((_r) => _r.body as null));
  }

  /**
   * getAllPolicyTemplates
   * @return OK
   */
  getAllPolicyTemplatesUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<PolicyTemplateDTO>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/opa/policy-templates`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PolicyTemplateDTO>>;
      }),
    );
  }
  /**
   * getAllPolicyTemplates
   * @return OK
   */
  getAllPolicyTemplatesUsingGET(): __Observable<Array<PolicyTemplateDTO>> {
    return this.getAllPolicyTemplatesUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<PolicyTemplateDTO>),
    );
  }

  /**
   * getPolicy
   * @param policyName policyName
   * @return OK
   */
  getPolicyUsingGETResponse(
    policyName: string,
  ): __Observable<__StrictHttpResponse<OpaPolicy>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/opa/${encodeURIComponent(String(policyName))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OpaPolicy>;
      }),
    );
  }
  /**
   * getPolicy
   * @param policyName policyName
   * @return OK
   */
  getPolicyUsingGET(policyName: string): __Observable<OpaPolicy> {
    return this.getPolicyUsingGETResponse(policyName).pipe(
      __map((_r) => _r.body as OpaPolicy),
    );
  }

  /**
   * createPolicy
   * @param params The `UiOpaControllerService.CreatePolicyUsingPOSTParams` containing the following parameters:
   *
   * - `policyName`: policyName
   *
   * - `opaRequest`: opaRequest
   *
   * @return OK
   */
  createPolicyUsingPOSTResponse(
    params: UiOpaControllerService.CreatePolicyUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<OpaPolicy>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.opaRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/opa/${encodeURIComponent(String(params.policyName))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OpaPolicy>;
      }),
    );
  }
  /**
   * createPolicy
   * @param params The `UiOpaControllerService.CreatePolicyUsingPOSTParams` containing the following parameters:
   *
   * - `policyName`: policyName
   *
   * - `opaRequest`: opaRequest
   *
   * @return OK
   */
  createPolicyUsingPOST(
    params: UiOpaControllerService.CreatePolicyUsingPOSTParams,
  ): __Observable<OpaPolicy> {
    return this.createPolicyUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as OpaPolicy),
    );
  }

  /**
   * editPolicy
   * @param params The `UiOpaControllerService.EditPolicyUsingPUTParams` containing the following parameters:
   *
   * - `policyName`: policyName
   *
   * - `opaRequest`: opaRequest
   *
   * @return OK
   */
  editPolicyUsingPUTResponse(
    params: UiOpaControllerService.EditPolicyUsingPUTParams,
  ): __Observable<__StrictHttpResponse<OpaPolicy>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.opaRequest;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/opa/${encodeURIComponent(String(params.policyName))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OpaPolicy>;
      }),
    );
  }
  /**
   * editPolicy
   * @param params The `UiOpaControllerService.EditPolicyUsingPUTParams` containing the following parameters:
   *
   * - `policyName`: policyName
   *
   * - `opaRequest`: opaRequest
   *
   * @return OK
   */
  editPolicyUsingPUT(
    params: UiOpaControllerService.EditPolicyUsingPUTParams,
  ): __Observable<OpaPolicy> {
    return this.editPolicyUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as OpaPolicy),
    );
  }

  /**
   * deletePolicy
   * @param policyName policyName
   */
  deletePolicyUsingDELETEResponse(
    policyName: string,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/cc-ui/v1/opa/${encodeURIComponent(String(policyName))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * deletePolicy
   * @param policyName policyName
   */
  deletePolicyUsingDELETE(policyName: string): __Observable<null> {
    return this.deletePolicyUsingDELETEResponse(policyName).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * executePolicy
   * @param params The `UiOpaControllerService.ExecutePolicyUsingPOSTParams` containing the following parameters:
   *
   * - `policyName`: policyName
   *
   * - `inputJson`: inputJson
   *
   * @return OK
   */
  executePolicyUsingPOSTResponse(
    params: UiOpaControllerService.ExecutePolicyUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<OpaPolicyExecutionResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.inputJson;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/opa/${encodeURIComponent(
          String(params.policyName),
        )}/execute`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OpaPolicyExecutionResult>;
      }),
    );
  }
  /**
   * executePolicy
   * @param params The `UiOpaControllerService.ExecutePolicyUsingPOSTParams` containing the following parameters:
   *
   * - `policyName`: policyName
   *
   * - `inputJson`: inputJson
   *
   * @return OK
   */
  executePolicyUsingPOST(
    params: UiOpaControllerService.ExecutePolicyUsingPOSTParams,
  ): __Observable<OpaPolicyExecutionResult> {
    return this.executePolicyUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as OpaPolicyExecutionResult),
    );
  }
}

module UiOpaControllerService {
  /**
   * Parameters for createPolicyUsingPOST
   */
  export interface CreatePolicyUsingPOSTParams {
    /**
     * policyName
     */
    policyName: string;

    /**
     * opaRequest
     */
    opaRequest: OpaPolicyRequest;
  }

  /**
   * Parameters for editPolicyUsingPUT
   */
  export interface EditPolicyUsingPUTParams {
    /**
     * policyName
     */
    policyName: string;

    /**
     * opaRequest
     */
    opaRequest: OpaPolicyRequest;
  }

  /**
   * Parameters for executePolicyUsingPOST
   */
  export interface ExecutePolicyUsingPOSTParams {
    /**
     * policyName
     */
    policyName: string;

    /**
     * inputJson
     */
    inputJson: string;
  }
}

export { UiOpaControllerService };
